import React, { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { OfferingDetailsDayPass } from "../template_offering_details_daypass";
import { useDiwanHubAnalytics } from "./diwan-hub_analytics";
import {
  generalInfo,
  partnerConfig,
  testimonials,
} from "./diwan-hub_partner_config";

const Theme = lazyWithRetry(() => import("./diwan-hub_theme"));

const faqs = [
  {
    question: "What are your hours?",
    answer:
      "We're open 24/7. Grab a coffee and let those creative juices flow, you genius.",
  },

  {
    question: "Is there somewhere I can park my car?",
    answer: "Of course! We offer public on-site parking.",
  },

  {
    question: "What's included with my day pass?",
    answer:
      "We offer coffee, snacks, high-speed internet, printing facilities and mentoring. Locked and loaded for your productivity PB.",
  },

  {
    question: "Is there somewhere I can make a call or have a meeting? ",
    answer:
      "We have a custom-built meeting room and board room, yours to be booked out by the hour as and when you need them. For events, why not hire out our events space, with optional catering. Go get 'em, tiger.",
  },

  {
    question: "Can I bring my own snacks? ",
    answer:
      "By all means, we have a dedicated chill-out area for snack munching and inspirational water-cooler chat. We also offer our own hot coffee and goodies.",
  },
];

export function OfferingDiwanHubDayPass() {
  useDiwanHubAnalytics();

  return (
    <Fragment>
      <Theme />
      <OfferingDetailsDayPass
        showAddress={false}
        showDirections
        partnerConfig={partnerConfig}
        data={{
          description: `Freedom to work on your own terms, connect to the community and get to work.`,
          testimonials: testimonials,
          faqs: faqs,
          generalInfo,
        }}
      />
    </Fragment>
  );
}
